import React from 'react'
import styled from 'styled-components'

import { Drawer } from '../drawer'

import { InfoDrawerBody } from './info-drawer-body'

import type { DrawerControlProps } from '../drawer'
import type { InfoDrawerBodyProps } from './info-drawer-body'

type InfoDrawerProps = DrawerControlProps & InfoDrawerBodyProps

export const InfoDrawer = ({
  onOpenChange,
  open,
  header,
  ...props
}: InfoDrawerProps) => (
  <Root title={header} open={open} onOpenChange={onOpenChange}>
    <InfoDrawerBody header={header} {...props} />
  </Root>
)

const Root = styled(Drawer)``
